'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgWelloPoint } from '@common/icon';
import { useAdpopcorn } from '@/modules/adpopcorn';
import type { ShortcutActionRowProps } from './KosafHouseholdShortcutRow';
export const WelloPointRewardShortcutRow = t0 => {
  const $ = _c(11);
  const {
    label,
    onNavigate
  } = t0;
  const {
    status,
    isExternalWebview,
    onClick,
    isOpening
  } = useAdpopcorn();
  if (isExternalWebview) {
    return null;
  }
  let t1;
  if ($[0] !== onClick || $[1] !== onNavigate || $[2] !== status) {
    t1 = () => {
      onClick();
      if (status === "ready") {
        onNavigate?.();
      }
    };
    $[0] = onClick;
    $[1] = onNavigate;
    $[2] = status;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgWelloPoint originalFill={true} className="size-24 shrink-0" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label) {
    t3 = <span className="line-clamp-1 font-500 text-Gray-900 typo-body3">{label}</span>;
    $[5] = label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClick || $[8] !== isOpening || $[9] !== t3) {
    t4 = <button type="button" onClick={handleClick} disabled={isOpening} className="flex w-full items-center gap-8 px-20 py-12 text-left transition-colors hover:bg-Gray-50 disabled:opacity-60">{t2}{t3}</button>;
    $[7] = handleClick;
    $[8] = isOpening;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};